<template>
    <div class="customMobile-layout-cls loginLoader bg-white h-100">
        <loader v-if="pageLoader"></loader>
        <div class="row h-100">
            <div class="col-12 col-md-7">
                <div class="d-flex flex-column justify-content-center authenticatorCal h-100"
                    v-if="gAuthenticatorEnabled == '0'">
                    <div class="capitalLoginForm d-flex flex-column justify-content-center h-100">
                        <div class="lt-aler-message" v-if="notification_msg != ''">
                            <alert-notification />
                        </div>
                        <img src="../../../../static/website/images/logo.svg" alt="Logo" width="300" class="loginLogo mb-2">
                        <h2 class="my-md-4">Welcome back! Good to see you again</h2>
                        <!-- <notifications class="customnotify-message" group="foo" :max="1" :ignoreDuplicates="true" :position="''"/> -->
                        <form v-on:submit.stop.prevent="submit()">
                            <div class="form-group" :class="(email != '')?'active':''">
                                <label class="labeltext">Email</label>
                                <input type="text" placeholder=" " class="form-control" v-model="email" name="email"
                                    v-validate="'required|email'" />
                                <span class="text-danger" v-if="submitted && errors.has('email')">{{
                                errors.first('email') }}</span>
                                <span class="ico"><i data-feather="user"></i></span>
                            </div>
                            <div class="form-group mb-2">
                                <div class="d-flex align-items-center justify-content-between mb-2">
                                    <label class="labeltext mb-0">Password</label>
                                    <router-link :to="'/forgot-password'" class="links textcolor"> Forgot Password?
                                    </router-link>
                                </div>
                                <div class="position-relative" :class="(password != '')?'password':''">
                                    <input :type="show_pass" class="form-control" v-model="password" placeholder=" "
                                        name="password" v-validate="'required'" />
                                    <div class="text-danger" v-if="submitted && errors.has('password')">{{
                                    errors.first('password') }}</div>
                                    <password-icon class="ico" v-model="show_pass"></password-icon>
                                </div>
                            </div>
                            <div class="form-group mb-2 d-flex align-items-center justify-content-between">
                                <div class="c_checkbox">
                                    <label class="customCheckbox mb-0">
                                        Remember me
                                        <input type="checkbox" v-model="remember_me" />
                                        <span class="checkmark"></span>
                                    </label>
                                </div>
                            </div>
                            <div class="form-group">
                                <input type="submit" class="cap_btn blue large_btn" value="Login" name="submitFrm"
                                    :class="(pageLoader)?'disabled':''" />
                            </div>
                            <div class="form-group d-flex justify-content-between mb-0 mob-center">
                                <p>Don’t have an account ?
                                    <router-link :to="'/register'" class="bold themecolor"> Sign Up</router-link>
                                </p>
                            </div>
                            <div class="form-group text-center"></div>
                        </form>
                        <div class="bottomContent position-absolute authorizedText">
                            <p>Authorized and Regulated Entities: 
                                
                                <a href="https://client.capitalwallet.com/" >Capital Wallet APAC</a>  | 
                                <a href="https://cp.capitalwallet.com/" class="bold active">Capital Wallet Global</a>
                            </p>
                        </div>
                        <!-- <div class="bottomContent position-absolute">
                            <p>Authorized and Regulated Entities: <a href="https://cp.capitalwallet.com/">Capitalwallet
                                    Europe</a> | <a href="https://client.capitalwallet.com/">Capitalwallet Others
                                </a>
                            </p>
                        </div> -->
                    </div>
                </div>
                <div class="capitalLoginForm d-flex flex-column justify-content-center h-100" v-else-if="gAuthenticatorEnabled == '1'">
                    <div class="lt-aler-message" v-if="notification_msg != ''">
                        <alert-notification />
                    </div>
                    <div class="capitalLoginFormMid">
                        <h2 class="mb-md-4">Security Verification</h2>
                        <p class="mb-1">To complete the request, please complete the following verification</p>
                        <p>Enter the 6 digit code from Google Authenticator.</p>
                        <div class="form-group">
                            <label class="labeltext" v-html="(faFlag)? 'Google verification code' :'Enter OTP'"></label>
                            <input type="text" placeholder=" " class="form-control" v-model="code" name="OTP"
                                v-validate="'required'" @keyup.enter="submitCode('')" />
                            <span class="text-danger" v-if="submitted && errors.has('OTP')">{{ errors.first('OTP')
                            }}</span>
                            <!-- <div class="form-group mb-2">
										<input placeholder=" " type="text" name="code" v-model="code" class="form-control" v-validate="{required:true}" :class="{ 'is-invalid': submittedCode && errors.has('code') }" />
										<label class="labeltext" v-html="(faFlag)? 'Google verification code' :'Enter otp'"></label>
										<span v-for="error in errors.collect('code')" class="text-danger">{{ error }}</span>
									</div> -->

                            <div class="form-group d-flex align-items-center justify-content-between mt-4 mt-md-5">
                                <input type="submit" class="cap_btn blue large_btn mb-2" value="Submit"
                                    :class="(pageLoader)?'disabled':''" name="submitFrm" @click="submitCode('')" />
                                <p class="mb-0"><a href="#" @click.prevent="gAuthenticatorEnabled = '0'">Back to
                                        login</a></p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-12 col-md-5 d-flex flex-column justify-content-center themeBG hide-767">
                <div class="capital_login">
                    <img src="../../../../static/website/images/login-img.png" class="mb-3 loginImg"
                        :alt="$env_var.productName" />
                    <!-- <h3>Welcome to {{$env_var.productName}}</h3> -->
                </div>
            </div>
        </div>
    </div>
</template>

<script>
var CryptoJS = require("crypto-js");
const crypto = require('crypto');
import * as types from '@/types'
import { mapActions } from 'vuex'
import TwoFa from '../security/security'
export default {
    name: 'App-Login',
    data() {
        return {
            pageLoader: false,
            notification_msg: '',
            notification_type: '',
            submitted: false,
            email: '',
            password: '',
            remember_me: false,
            show_pass: 'password',

            code: '',
            submittedCode: false,
            gAuthenticatorEnabled: '0',
            faFlag: false
        }
    },
    components: {
        appTwofa: TwoFa
    },
    methods: {
        ...mapActions({
            _runLogin: types.RUN_LOGIN,
            _runLoginWithHash: types.RUN_LOGIN_WITH_HASH,
            _runUserLogin2FA: types.RUN_USER_LOGIN_2FA,
            _runstateLoad: types.RUN_STATE_LOAD,
            _runLogout: types.RUN_LOGOUT
        }),
        logout() {
            let input_json = {
                'globalParams': {},
                'localParams': { "parameter": this }
            }
            this._runLogout(input_json)
        },
        submitCode(getCode) {
            if (this.pageLoader) { return; }
            const _that = this
            if (getCode != '') {
                _that.code = getCode
            }

            _that.submittedCode = true;

            const ALGO = "aes-256-cbc";
            const ENC = "bf3c199c2470cb477d907b1e0917c17b";
            const IV = "5183666c72eec9e4";
            let mykey = crypto.createCipheriv(ALGO, ENC, IV);
            let hashedstr = mykey.update(_that.password, 'utf8', 'hex');
            hashedstr += mykey.final('hex');
            
            // const mykey = crypto.createCipher('aes-128-cbc', 'F*V(I)e^E#1108@3');
            // let hashedstr = mykey.update(_that.password, 'utf8', 'hex')
            // hashedstr += mykey.final('hex');

            _that.$validator.validate().then(valid => {
                if (valid) {
                    let input_json = {
                        'globalParams': {
                            "google_token": _that.code.toString(),
                            "email": _that.email,
                            "password": hashedstr
                        },

                        'localParams': { "parameter": _that }
                    }
                    if (localStorage.getItem('transfer_token')) {
                        input_json.globalParams['api_query'] = { 'transfer': localStorage.getItem('transfer_token') }
                    }
                    _that._runUserLogin2FA(input_json)
                }
            });
        },
        submit() {
            if (this.pageLoader) { return; }
            if (this.remember_me) {
                var email = this.email;
                var password = this.password;
                // set cookies to expire in 14 days
                this.$cookies.set("email", email, "14d");
                this.$cookies.set("password", password, "14d");
                this.$cookies.set("remember", true, "14d");
            } else {
                // reset cookies
                this.$cookies.set("email", null);
                this.$cookies.set("password", null);
                this.$cookies.set("remember", null);
            }
            const _that = this
            this.submitted = true;
            this.$validator.validate().then(valid => {
                if (valid) {
                    let input_json = {
                        'globalParams': {
                            email: _that.email,
                            password: _that.password
                        },
                        'localParams': {
                            "parameter": _that
                        }
                    }
                    if (localStorage.getItem('transfer_token')) {
                        input_json.globalParams['api_query'] = { 'transfer': localStorage.getItem('transfer_token') }
                    }
                    _that._runLogin(input_json)
                }
            })
        }
    },
    created() {
        const _that = this
        if (this.$route.query.transfer) {
            let transfer_token = this.$route.query.transfer
            localStorage.setItem('transfer_token', transfer_token)
            // console.log('-------transfer_token--->',transfer_token)
            this.$router.replace({})
        }
        if (this.$route.query.token) {
            let user = {
                "password": "",
                "email": "",
                "username": "",
                "client_code": "",
                "profile": {},
                "token": this.$route.query.token,
                "loggedIn": true
            }

            localStorage.setItem('user', btoa(JSON.stringify(user)))
            this._runstateLoad({ 'globalParams': {}, 'localParams': { "parameter": this, 'page': 'indexVue' } })
        }
        if (this.$route.query.verify) {
            let verify = this.$route.query.verify
            this.$router.replace({ query: '' });
            this._runLoginWithHash({
                'globalParams': {
                    "verify": verify
                },
                'localParams': { "parameter": _that }
            })

        }
        let remember = this.$cookies.get("remember");
        if (remember == 'true') {
            this.email = this.$cookies.get("email");
            this.password = this.$cookies.get("password");
            this.remember_me = true
        } else {
            this.email = '';
            this.password = '';
            this.remember_me = false
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/website/user/login.vue